import React, { useEffect, useState } from "react";
import styles from "./PackageDetail.module.css";
import IndicatorLabel from "../IndicatorLabel/IndicatorLabel";
import df from "../../utils/dateFormater";
import packageImg from "../../assets/images/MENU PACKAGE.svg";
import { TiDocumentText } from "react-icons/ti";
import { CiTimer } from "react-icons/ci";
import { CiCalendar } from "react-icons/ci";
import PersonIcon from "@material-ui/icons/Person";
import { FaTemperatureHigh } from "react-icons/fa";
import { Tooltip } from "@material-ui/core";
import chemicalImg from "../../assets/images/QUIMICO.svg";
import materialImg from "../../components/NavBar/Menu/icons/INSTRUMENTS.svg";
import t from "../../utils/translation";
import request from "../../utils/request";
import ModalLoading from "../ModalLoading/ModalLoading";
import { IoReload } from "react-icons/io5";
import Redirect from "../../utils/Redirect";

import toStartIcon from "../../assets/images/Icono To start.svg";
import inProgressIcon from "../../assets/images/Icono In progress.svg";
import finishedIcon from "../../assets/images/Icono Finished.svg";
import ObservationCard from "../ObservationCard/ObservationCard";
import { FiImage } from "react-icons/fi";

export default function PackageDetail({
  locale,
  packageId,
  storage,
  release,
  dispatch,
}) {
  const [pkg, setPkg] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [indicators, setIndicators] = useState([]);

  const [showImageModal, setShowImageModal] = useState(false);

  const handleOpenImageModal = () => {
    if (pkg.packageImageLink) setShowImageModal(true);
  };

  const handleCloseImageModal = () => {
    setShowImageModal(false);
  };

  const getPackageId = async () => {
    setModalLoading(true);
    try {
      await request()
        .get(`/api/package/info?packageId=${packageId}`)
        .then((response) => {
          const data = response.data;
          setPkg(data);
          const indicators = response.data.indicators;
          setIndicators(indicators);
        });
    } catch {
    } finally {
      setModalLoading(false);
    }
  };

  const handleDetail = (id) => {
    if (pkg.chargeRelated.chargeStatus === 3) return;
    const path =
      pkg.chargeRelated.chargeStatus === 2
        ? `/apploadDetail/${id}`
        : `/appcycledetail/${id}`;

    Redirect({
      redirect: true,
      path: path,
      parameters: {
        packageRecord: true,
        packageId,
        storage,
        release,
        dispatch,
      },
    });
  };

  const statusPackage = (packageValue, loadValue) => {
    switch (packageValue) {
      case 1:
        return t("Assembling", locale);
      case 2:
        return t("ReadyForLoad", locale);
      case 3:
        return t("InLoad", locale);
      case 4:
        return t("Sterilized", locale);
      case 6:
        return t("BlankEntry126", locale) || "Released";
      case 7:
        return t("BlankEntry127", locale) || "Rejected";
      case 8:
        return t("BlankEntry239", locale) || "Rejected in Area";
      case 9:
        return t("BlankEntry240", locale) || "Accepted in Area";
      case 10:
        return t("BlankEntry196", locale) || "Dispatched";
      case 11:
        return t("BlankEntry200", locale) || "Missing";
      case 12:
        return t("BlankEntry241", locale) || "Reception Completed";
      case 13:
        return t("BlankEntry242", locale) || "Reception Partial";
      default:
        return "Unknown Status";
    }
  };

  const getResultText = (result) => {
    switch (result) {
      case 3:
        return t("RejectedSpan");
      case 4:
        return t("AcceptedSpan");
      default:
        return "";
    }
  };

  const getResultBIText = (result) => {
    switch (result) {
      case 1:
        return t("PositiveSpan");
      case 2:
        return t("NegativeSpan");
      case 3:
        return t("CanceledSpan");
      default:
        return "";
    }
  };

  const getEvaluationText = (result) => {
    switch (result) {
      case 0:
        return t("AgreeSpan");
      case 1:
        return t("DisagreeSpan");
      default:
        return "";
    }
  };
  const status = (value) => {
    return value === 2
      ? t("ToStartSpan", locale) || "To Start"
      : value === 3
      ? t("StartedSpan", locale) || "Started"
      : value === 9
      ? t("BlankEntry126", locale) || "Released"
      : value === 10
      ? t("BlankEntry127", locale) || "Rejected"
      : value === 11
      ? t("BlankEntry128", locale) || "Partially Released"
      : t("FinishedSpan", locale) || "Finished";
  };

  const findImg = (value) => {
    return value === 2
      ? toStartIcon
      : value === 3
      ? inProgressIcon
      : finishedIcon;
  };

  useEffect(() => {
    getPackageId();
    return () => {
      setPkg([]);
    };
  }, []);

  return (
    <div className={styles.container}>
      <ModalLoading open={modalLoading} />
      {showImageModal && (
        <div className={styles.modalOverlay} onClick={handleCloseImageModal}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={pkg.packageImageLink}
              alt="Package"
              className={styles.modalImage}
            />
          </div>
        </div>
      )}

      <div className={styles.header}>
        <div className={styles.topHeader}>
          <div className={styles.titleContainer}>
            <p className={styles.title}>
              {pkg.chargeRelated?.chargeStatus === 4 && (
                <Tooltip
                  title={
                    <span>{` ${
                      pkg.chargeRelated.hasPositive
                        ? t("BlankEntry18")
                        : t("BlankEntry19")
                    }`}</span>
                  }
                  arrow
                >
                  <div
                    className={`${styles.hasPositive} ${
                      pkg.hasPositive
                        ? styles.red
                        : pkg.indicators.length === 0
                        ? styles.green
                        : pkg.indicators.every((i) => i.reading || i.readingBI)
                        ? pkg.indicators.some(
                            (i) =>
                              i.reading?.result === 4 ||
                              i.readingBI?.resultEnum === 2
                          )
                          ? styles.green
                          : styles.gray
                        : styles.gray
                    }`}
                  ></div>
                </Tooltip>
              )}
              {pkg.packageNumber} - {pkg?.description}
            </p>
              <FiImage
                onClick={handleOpenImageModal}
                className={`${styles.imageIconButton} ${styles.whiteIcon}`}
                size={18}
              />
          </div>
          <img src={packageImg} className={styles.packageImage} alt={""} />
        </div>

        <div className={styles.headerDetails}>
          <div className={styles.detailItem}>
            <span className={styles.info}>
              <CiCalendar className={styles.iconStyle} />
              {df(pkg.creationDate, "dateTime")}
            </span>
          </div>
          <div className={styles.detailItem}>
            <span className={styles.info}>
              <TiDocumentText className={styles.iconStyle} />
              {pkg.methodName}
            </span>
          </div>
          <div className={styles.detailItem}>
            <TiDocumentText className={styles.iconStyle} />
            <span className={styles.info}>
              {pkg.chargeRelated
                ? statusPackage(
                    pkg.packageStatus,
                    pkg.chargeRelated.chargeStatus
                  )
                : statusPackage(pkg.packageStatus)}
            </span>
          </div>
          {/* {pkg.observations && (
            <div className={styles.detailItem}>
              <TiDocumentText className={styles.iconStyle} />
              <span className={styles.info}>{pkg.observations}</span>
            </div>
          )} */}
        </div>
      </div>
      {(pkg.packageStatus === 6 || pkg.packageStatus === 7) && (
        <div className={styles.header}>
          <div className={styles.topHeader}>
            <div>
              <p className={styles.title}>
                {`${statusPackage(pkg.packageStatus)} ${
                  pkg.packageStatus === 6 ? `- ${pkg.locationName}` : ""
                }`}
              </p>
            </div>
          </div>

          <div className={styles.headerDetails}>
            <div className={styles.detailItem}>
              <span className={styles.info}>
                <CiCalendar className={styles.iconStyle} />
                {df(pkg.authorizedDate, "dateTime")}
              </span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.info}>
                <PersonIcon className={styles.iconStyle} />
                {pkg.authorizedByName}
              </span>
            </div>
          </div>
        </div>
      )}
      {pkg.chargeRelated && (
        <div className={styles.header}>
          <div className={styles.headerTitleContainer}>
            <p
              className={styles.title}
              onClick={() => handleDetail(pkg.chargeRelated.chargeId)}
            >
              {pkg.chargeRelated.chargeStatus === 4 && (
                <Tooltip
                  title={
                    <span>{` ${
                      pkg.chargeHasPositive
                        ? t("BlankEntry18")
                        : t("BlankEntry19")
                    }`}</span>
                  }
                  arrow
                >
                  <div
                    className={`${styles.hasPositive} ${
                      pkg.chargeRelated.chargeHasPositive
                        ? styles.red
                        : pkg.chargeRelated.chargeIndicatorsUnlinked
                        ? styles.gray
                        : styles.green
                    }`}
                  ></div>
                </Tooltip>
              )}
              {`${t("CycleNumberSpan", locale) || "Cycle Number"}: ${
                pkg.chargeRelated?.cycleNumber ?? ""
              }`}
            </p>

            <div className={styles.detailItem}>
              <div className={styles.detailItem} style={{ gap: "10px" }}>
                <img
                  className={styles.iconImg}
                  alt={status(pkg.chargeRelated?.chargeStatus)}
                  src={findImg(pkg.chargeRelated?.chargeStatus)}
                />
                <span className={styles.infoStatus}>
                  {status(pkg.chargeRelated?.chargeStatus)}
                </span>
              </div>
            </div>
          </div>
          <div>
            <p className={styles.sectionSubTitle}>
              {pkg.chargeRelated.sterilizerName} - {pkg.methodName}
            </p>
          </div>
          <div className={styles.headerDetails}>
            <div>
              <div className={styles.detailItem}>
                <IoReload className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("StartedSpan") || "Started"}:{" "}
                  <span className={styles.info}>
                    {df(pkg.chargeRelated.cicleStartDate, "dateTime")}
                  </span>
                  {}
                </p>
              </div>
              <div className={styles.detailItem}>
                <IoReload className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("FinishedSpan") || "Finished"}:{" "}
                  <span className={styles.info}>
                    {df(pkg.chargeRelated.cicleFinishDate, "dateTime")}
                  </span>
                </p>
              </div>
            </div>

            <div>
              <div className={styles.detailItem}>
                <PersonIcon className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("OperatorSpan") || "User"}:
                  <span className={styles.info}>
                    {pkg.chargeRelated.operator}
                  </span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <TiDocumentText className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("UsedProgramSpan") || "Used Program"}:{" "}
                  <span className={styles.info}>
                    {pkg.chargeRelated.usedProgram}
                  </span>
                </p>
              </div>
            </div>

            <div>
              <div className={styles.detailItem}>
                <FaTemperatureHigh className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("TemperatureSpan") || "Temperature"}:{" "}
                  <span className={styles.info}>
                    {pkg.chargeRelated.cicleTemperature &&
                      pkg.chargeRelated.cicleTemperature +
                        " " +
                        pkg.chargeRelated.temperatureUnit}
                  </span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <CiTimer className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("TimeSpan") || "Time"}:{" "}
                  <span className={styles.info}>
                    {pkg.chargeRelated.cicleTime &&
                      pkg.chargeRelated.cicleTime +
                        " " +
                        pkg.chargeRelated.timeUnit}
                  </span>
                </p>
              </div>
            </div>
          </div>
          {pkg.chargeRelated.cicleObservations && (
            <div className={styles.observationSection2}>
              <p className={`${styles.observationTitle2}`}>
                {t("ObservationSpan")}
              </p>

              <div className={styles.observationContainer2}>
                <p className={styles.observation2}>
                  {pkg.chargeRelated.cicleObservations}
                </p>
              </div>
            </div>
          )}
        </div>
      )}
      {/* Sección de Materiales */}
      {pkg && (
        <section className={styles.section}>
          <div className={styles.imageTitleContainer}>
            <img src={materialImg} alt="Materials" className={styles.image} />
            <h2 className={styles.sectionTitle}>
              {t("PackageDetailMaterials", locale) || "Materials"}
            </h2>
          </div>
          {pkg.materials && pkg.materials.length === 0 ? (
            <p className={styles.noDataMessage}>No materials available.</p>
          ) : (
            <div className={styles.materialsContainer}>
              {pkg.materials &&
                pkg.materials.map((material) => (
                  <div className={styles.material} key={material.materialId}>
                    {/* <div className={styles.imgMaterialContainer}></div> */}
                    <div className={styles.materialTextContainer}>
                      <p className={styles.materialName}>
                        {material.materialName}
                      </p>
                      <div className={styles.iconWrapper}>
                        {<div className={styles.icon}></div>}
                      </div>
                      <p className={styles.materialQuantity}>
                        {material.materialSerial
                          ? `${t("SerialSpan")}: ${material.materialSerial}`
                          : `${t("QuantitySpan")}: ${material.quantity}`}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </section>
      )}

      {[1, 2, 3].includes(pkg.packageStatus) ? (
        <section className={styles.section}>
          <div className={styles.imageTitleContainer}>
            <img src={chemicalImg} alt="Indicators" className={styles.image} />
            <h2 className={styles.sectionTitle}>
              {t("PackageDetailIndicators", locale)}
            </h2>
          </div>
          {pkg.indicators && pkg.indicators.length === 0 ? (
            <p className={styles.noDataMessage}>{t("NoIndicatorsSpan")}.</p>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              {pkg.indicators?.map((indicator) => (
                <div className={styles.indicatorItem}>
                  <IndicatorLabel
                    quantity={indicator.quantity}
                    readingBiId={indicator.readingBI?.id}
                    name={indicator.indicatorName}
                    lot={indicator.lot}
                    serial={indicator.serial}
                    expirationDate={indicator.expirationDate}
                    backgroundColor={"white"}
                    border={true}
                    resultBiologic={indicator.readingBI?.resultEnum}
                    detail={true}
                    statusDescription={indicator.readingBI?.status}
                  />
                </div>
              ))}
            </div>
          )}
        </section>
      ) : (
        <section className={styles.section}>
          <div className={styles.imageTitleContainer}>
            <img src={chemicalImg} alt="Indicators" className={styles.image} />
            <h2 className={styles.sectionTitle}>
              {t("PackageDetailIndicators", locale) || "Indicators"}
            </h2>
          </div>
          {pkg.indicators && pkg.indicators.length === 0 ? (
            <p className={styles.noDataMessage}>{t("NoIndicatorsSpan")}.</p>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              {indicators.map((indicator) => {
                // Determinamos si usar `reading` o `readingBI`
                const isBTIndicator = indicator.indicatorName
                  .toUpperCase()
                  .includes("BT");
                const readingToUse = isBTIndicator
                  ? indicator.readingBI
                  : indicator.reading;

                return (
                  <Tooltip
                    key={indicator.id}
                    title={
                      <div>
                        <div>Product: {indicator.indicatorName}</div>
                        <div>Lot: {indicator.lot}</div>
                        {indicator.serial && (
                          <div>
                            {t("SerialSpan")}: {indicator.serial}
                          </div>
                        )}
                        {readingToUse !== null ? (
                          isBTIndicator ? (
                            // Tooltip cuando se usa `readingBI`
                            <div>
                              <div>
                                {t("StatusSpan")}: {t("ReadSpan")}
                              </div>
                              <div>
                                {t("ReadingNroSpan") || "Reading nro"}:{" "}
                                {readingToUse.readingNumber}
                              </div>
                              <div>
                                {t("ResultEnum") || "Result"}:{" "}
                                {getResultBIText(readingToUse.resultEnum)}
                              </div>
                              {/* <div>
                              {t("UserEvaluationSpan")}: {getEvaluationText(readingToUse.visualResult)}
                            </div> */}
                              <div>
                                {t("CreationDateSpan") || "Date"}:{" "}
                                {df(readingToUse.resultDate, "dateTime")}
                              </div>
                              <div>
                                {t("temperatureSpan") || "Temperature"} :{" "}
                                {readingToUse.averageTemperatureFormat}
                              </div>
                              <div>
                                {t("IncubatorTimeSpan") || "Incubator time"}:{" "}
                                {readingToUse.incubationTime}
                              </div>
                              <div>
                                {t("programSpan") || "Program"}:{" "}
                                {readingToUse.programName}
                              </div>
                              <div>
                                {t("positionSpan") || "Position"}:{" "}
                                {readingToUse.positionNumber}
                              </div>
                            </div>
                          ) : (
                            // Tooltip cuando se usa `reading`
                            <div>
                              <div>
                                {t("StatusSpan")}: {t("ReadSpan")}
                              </div>
                              <div>
                                {t("ReadingNroSpan") || "Reading nro"}:{" "}
                                {readingToUse.readNumber}
                              </div>
                              <div>
                                {t("AutomaticReadoutSpan")}:{" "}
                                {getResultText(readingToUse.result)}
                              </div>
                              <div>
                                {t("UserEvaluationSpan")}:{" "}
                                {getEvaluationText(readingToUse.visualResult)}
                              </div>
                              <div>
                                {t("CreationDateSpan") || "Date"}:{" "}
                                {df(readingToUse.creationTest, "dateTime")}
                              </div>
                            </div>
                          )
                        ) : (
                          <div>
                            {t("StatusSpan")}: {t("UnreadSpan")}.{" "}
                            {/* {t("UseTrazantoLensSpan")} */}
                          </div>
                        )}
                      </div>
                    }
                    arrow
                  >
                    <div className={styles.indicatorItem}>
                      <IndicatorLabel
                        quantity={indicator.quantity}
                        name={indicator.indicatorName}
                        lot={indicator.lot}
                        serial={indicator.serial}
                        expirationDate={indicator.expirationDate}
                        backgroundColor={"white"}
                        border={true}
                        resultCH={readingToUse?.result}
                        userResultCH={readingToUse?.visualResult}
                        resultBiologic={indicator.readingBI?.resultEnum}
                        detail={true}
                        statusDescription={indicator.readingBI?.status}
                      />
                    </div>
                  </Tooltip>
                );
              })}
            </div>
          )}
        </section>
      )}

      {/* Sección de Observaciones */}
      {pkg && (
        <ObservationCard
          movementsObservations={pkg.movementsObservations}
          pkg={true}
        />
      )}
    </div>
  );
}
